import React from "react";
import "./pathNotFound.css";
import { useNavigate } from "react-router-dom";
import { environment } from "../../environments/environment";
import notFoundSvg from "../../assets/Images/notFound.svg"

export const PathNotFoundComponent = () => {
  const navigate = useNavigate();
  const basePath = environment.basePath;

  const handleGoHomeNavigation = () => {
    navigate(basePath + "/customDashboard");
  };

  return (
    <>
      <section className="notFound-main-cont">
        <div className="notFound-text-cont">
          <p>
            <span>So sorry!</span> <br />
            The page you are looking for cannot be found.
          </p>
          <button onClick={handleGoHomeNavigation} className="ellipsis">
            Go Home
          </button>
          
        </div>

        <div className="notFound-svg-cont">
            <img src={notFoundSvg} alt="" />
          </div>
      </section>
    </>
  );
};
